import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyBets } from "./cl_MyBets";

function MyBets() {
    const dispatch = useDispatch();
    const {myBetsData} = useSelector((state) => state?.mybets);
    useEffect(() => {
        dispatch(fetchMyBets());
    },[])

    return (
        <React.Fragment>
            <div className="SB-myAccountSection-container SB-myBets">
                <div className="">
                    <div className="SB-pageHeader">
                        <div className="SB-pageHeader-title">My Bets</div>
                    </div>
                    <div className="SB-myBets">
                        <div className="SB-myBetsBox-group">
                            <div className="SB-betBox SB-gameBet">
                                <div className="SB-betBox-header">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-betType">
                                                Defender
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-badge SB-open">
                                                Open
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-betBox-betStatusDetails">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <div className="SB-betID">
                                                ID:
                                                1cc384e4-5983-4d51-a130-e9c7f0fbd0f8
                                            </div>
                                        </div>
                                    </div>
                                    <div className="SB-placedOnDate">
                                        Placed on: 08 Jan at 21:00
                                    </div>
                                </div>
                                <div className="SB-betBox-stakeRetuns">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-label">
                                                Stake:
                                            </span>
                                            <span className="SB-value">
                                                INR 50.00
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-label">
                                                To Payout:{" "}
                                            </span>
                                            <span className="SB-value">
                                                INR 00.00
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox SB-gameBet">
                                <div className="SB-betBox-header">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-betType">
                                                Defender
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-badge SB-open">
                                                Open
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-betBox-betStatusDetails">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <div className="SB-betID">
                                                ID:
                                                1cc384e4-5983-4d51-a130-e9c7f0fbd0f8
                                            </div>
                                        </div>
                                    </div>
                                    <div className="SB-placedOnDate">
                                        Placed on: 08 Jan at 21:10
                                    </div>
                                </div>
                                <div className="SB-betBox-stakeRetuns">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-label">
                                                Stake:
                                            </span>
                                            <span className="SB-value">
                                                INR 50.00
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-label">
                                                To Payout:{" "}
                                            </span>
                                            <span className="SB-value">
                                                INR 100.00
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox SB-gameBet">
                                <div className="SB-betBox-header">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-betType">
                                                Defender
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-badge SB-open">
                                                Open
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-betBox-betStatusDetails">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <div className="SB-betID">
                                                ID:
                                                1cc384e4-5983-4d51-a130-e9c7f0fbd0f8
                                            </div>
                                        </div>
                                    </div>
                                    <div className="SB-placedOnDate">
                                        Placed on: 08 Jan at 21:10
                                    </div>
                                </div>
                                <div className="SB-betBox-stakeRetuns">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-label">
                                                Stake:
                                            </span>
                                            <span className="SB-value">
                                                INR 50.00
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-label">
                                                To Payout:{" "}
                                            </span>
                                            <span className="SB-value">
                                                INR 100.00
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox SB-gameBet">
                                <div className="SB-betBox-header">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-betType">
                                                Penalty shootout
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-badge SB-open">
                                                Open
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-betBox-betStatusDetails">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <div className="SB-betID">
                                                ID:
                                                1cc384e4-5983-4d51-a130-e9c7f0fbd0f8
                                            </div>
                                        </div>
                                    </div>
                                    <div className="SB-placedOnDate">
                                        Placed on: 08 Jan at 21:10
                                    </div>
                                </div>
                                <div className="SB-betBox-stakeRetuns">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-label">
                                                Stake:
                                            </span>
                                            <span className="SB-value">
                                                INR 50.00
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-label">
                                                To Payout:{" "}
                                            </span>
                                            <span className="SB-value">
                                                INR 00.00
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox SB-gameBet">
                                <div className="SB-betBox-header">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-betType">
                                                Blackjack Salon Priv
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-badge SB-open">
                                                Open
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-betBox-betStatusDetails">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <div className="SB-betID">
                                                ID:
                                                1cc384e4-5983-4d51-a130-e9c7f0fbd0f8
                                            </div>
                                        </div>
                                    </div>
                                    <div className="SB-placedOnDate">
                                        Placed on: 08 Jan at 21:10
                                    </div>
                                </div>
                                <div className="SB-betBox-stakeRetuns">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-label">
                                                Stake:
                                            </span>
                                            <span className="SB-value">
                                                INR 50.00
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-label">
                                                To Payout:{" "}
                                            </span>
                                            <span className="SB-value">
                                                INR 00.00
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox SB-gameBet">
                                <div className="SB-betBox-header">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-betType">
                                                Casino Holdem
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-badge SB-open">
                                                Open
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-betBox-betStatusDetails">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <div className="SB-betID">
                                                ID:
                                                1cc384e4-5983-4d51-a130-e9c7f0fbd0f8
                                            </div>
                                        </div>
                                    </div>
                                    <div className="SB-placedOnDate">
                                        Placed on: 08 Jan at 21:10
                                    </div>
                                </div>
                                <div className="SB-betBox-stakeRetuns">
                                    <div className="SB-contentBlock">
                                        <div className="SB-leftContent">
                                            <span className="SB-label">
                                                Stake:
                                            </span>
                                            <span className="SB-value">
                                                INR 50.00
                                            </span>
                                        </div>
                                        <div className="SB-rightContent">
                                            <span className="SB-label">
                                                To Payout:{" "}
                                            </span>
                                            <span className="SB-value">
                                                INR 00.00
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="SB-pagination">
                        <div className="SB-pagination-container">
                            <ul>
                                <li>
                                    <a className="SB-pagination-control SB-pagnination-left SB-disabled">
                                        <div className="SB-iconSVG">
                                            <svg
                                                version="1.1"
                                                id="Layer_1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 32 32"
                                                style={{
                                                    enableBackground:
                                                        "new 0 0 32 32",
                                                }}
                                                xmlSpace="preserve">
                                                <polygon points="22.2,32 6.6,16.4 6.6,15.6 22.2,0 25.4,3.1 12.7,16 25.4,28.7"></polygon>
                                            </svg>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a className="SB-pagination-item active">
                                        1
                                    </a>
                                </li>
                                <li>
                                    <a className="SB-pagination-item">2</a>
                                </li>
                                <li>
                                    <a className="SB-pagination-item">3</a>
                                </li>
                                <li>
                                    <a className="SB-pagination-item">4</a>
                                </li>
                                <li>
                                    <a className="SB-pagination-item">5</a>
                                </li>
                                <li>
                                    <a className="SB-pagination-control SB-pagnination-right">
                                        <div className="SB-iconSVG">
                                            <svg
                                                version="1.1"
                                                id="Layer_1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 32 32"
                                                style={{
                                                    enableBackground:
                                                        "new 0 0 32 32",
                                                }}
                                                xmlSpace="preserve">
                                                <polygon points="9.8,0 25.4,15.6 25.4,16.4 9.8,32 6.6,28.8 19.3,16 6.6,3.2 "></polygon>
                                            </svg>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="SB-myAccountSection-tabs d-none">
                        <ul>
                            <li className="active">
                                <div className="SB-tab-item">All bets</div>
                            </li>
                            <li>
                                <div className="SB-tab-item">Cash out</div>
                            </li>
                        </ul>
                    </div>
                    <div className="SB-msgBox d-none">
                        <div className="SB-msgBox-container">
                            Currently there are no bets available.
                        </div>
                    </div>
                    <div className="SB-myBetsBox-group d-none">
                        <div className="SB-betBox SB-myBet SB-accordion">
                            <div className="SB-betBox-header SB-accordion-header SB-arrowBefore">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <span className="SB-betType">
                                            SplitBet (3)
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-badge SB-won">
                                            ACCEPTED
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-betStatusDetails">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-betID">
                                            ID: AAA15362
                                        </div>
                                        <div
                                            className="SB-iconSVG SB-iconCopy"
                                            title="Copy">
                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                {/* <use xlink:href="images/sprite-other-icons.svg#icon-copy"></use> */}
                                            </svg>
                                        </div>
                                        <span className="SB-copiedTxt">
                                            Copied..!
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <div className="SB-bonus">
                                            <span>2%</span>
                                            {/* <!-- <span className="sb-icon icon-bonus"></span> --> */}
                                            <div
                                                className="SB-iconSVG "
                                                title="bonus">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    {/* <use xlink:href="images/sprite-other-icons.svg#icon-bonus"></use> */}
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-placedOnDate">
                                            Placed on: 29 Jan at 21:00
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <button className="btn SB-btnPrimary active SB-btnRebet">
                                            Rebet
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-accordion-content">
                                <div className="SB-betBox-content">
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-fixtureInfo">
                                            <span className="SB-bet-eventCode">
                                                20254
                                            </span>
                                            <a
                                                href=""
                                                className="SB-bet-fixture">
                                                Everton v Newcastle{" "}
                                            </a>
                                            <span className="SB-bet-dateandtime">
                                                {" "}
                                                @ 30 Jan at 18:00
                                            </span>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Everton
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.57
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Newcastle
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.57
                                                    </span>
                                                    <span className="SB-badge SB-notStarted">
                                                        Not Started
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Match Result
                                        </div>
                                    </div>
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-fixtureInfo">
                                            <span className="SB-bet-eventCode">
                                                20254
                                            </span>
                                            <a
                                                href=""
                                                className="SB-bet-fixture">
                                                Crystal Palace v Wolves
                                            </a>
                                            <span className="SB-bet-dateandtime">
                                                {" "}
                                                @ 30 Jan at 18:00
                                            </span>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Under 2.5
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.57
                                                    </span>
                                                    <span className="SB-badge SB-notStarted">
                                                        Not Started
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Over/Under
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-splitBet-info">
                                    <div className="SB-table SB-tbl-splitBet">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Grp</th>
                                                    <th>Com</th>
                                                    <th>Selections</th>
                                                    <th>Bonus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>3</td>
                                                    <td>3</td>
                                                    <td>-</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="SB-table SB-tbl-splitBet SB-tbl-PotentialWinnings">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th colspan="2">
                                                        Potential Winnings
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="SB-label">
                                                            Min Odds
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="SB-value">
                                                            10.00
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="SB-label">
                                                            Max Odds
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="SB-value">
                                                            21.00
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="SB-label">
                                                            Min Win
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="SB-value">
                                                            333333333333333333.33
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="SB-label">
                                                            Max Win
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="SB-value">
                                                            1650
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-stakeRetuns">
                                <div className="SB-contentBlock SB-betBox-stake">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">Stake:</span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 50.00
                                        </span>
                                    </div>
                                </div>
                                {/* <!-- <div className="SB-contentBlock SB-betBox-tax">
                                                <div className="SB-leftContent">
                                                    <span className="SB-label">WHT 15%:</span>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-value">₦ 85.00</span>
                                                </div>
                                            </div> --> */}
                                <div className="SB-contentBlock SB-betBox-returns">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">
                                            Total Returns:
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <div className="SB-value">
                                            <div className="SB-iconSVG SB-infoIcon animate__animated pulsate">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    {/* <use xlink:href="images/sprite-other-icons.svg#icon-info"></use> */}
                                                </svg>
                                            </div>
                                            <div
                                                className="SB-tooltip"
                                                style={{ display: "none" }}>
                                                <span className="SB-tooltipTxt">
                                                    Max Potential payout for the
                                                    above selections is capped
                                                    to 40,000,000 NGN
                                                </span>
                                            </div>
                                            <span>₦ 41,000,000.00</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-cashout-container">
                                <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                    Cashout ₦ 94.5
                                </button>
                                <div className="SB-betBox-btnCashout-container d-none">
                                    <button className="btn SB-btnMedium SB-btnCancel">
                                        Cancel
                                    </button>
                                    <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active">
                                        Confirm ₦ 94.5
                                    </button>
                                </div>
                                <div className="SB-betBox-cashOut-betStatusLoader d-none">
                                    <div className="SB-betBox-cashOut-betStatusLoader-txtContainer">
                                        Waiting
                                    </div>
                                    <div className="SB-loader"></div>
                                </div>
                                <div className="SB-betBox-cashout-statusMessage SB-success d-none">
                                    Cashout Successfull.
                                </div>
                                <div className="SB-betBox-cashout-statusMessage SB-failure d-none">
                                    Cashout rejected
                                </div>
                            </div>
                        </div>
                        <div className="SB-betBox SB-betBuider SB-accordion">
                            <div className="SB-betBox-header SB-accordion-header SB-arrowBefore">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-betSlip-betBuilderIcon SB-iconSVG">
                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                {/* <use xlink:href="images/sprite-other-icons.svg#icon-bet-builder"></use> */}
                                            </svg>
                                        </div>
                                        <span className="SB-betType">
                                            BetBuilder
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-badge SB-won">
                                            ACCEPTED
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-betStatusDetails">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-betID">
                                            ID: AAA52316
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <div className="SB-bonus">
                                            <span>2%</span>
                                            {/* <!-- <span className="sb-icon icon-bonus"></span> --> */}
                                            <div
                                                className="SB-iconSVG "
                                                title="bonus">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    {/* <use xlink:href="images/sprite-other-icons.svg#icon-bonus"></use> */}
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-placedOnDate">
                                            Placed on: 29 Jan at 21:00
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <button className="btn SB-btnPrimary active SB-btnRebet">
                                            Rebet
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-accordion-content">
                                <div className="SB-betBox-content">
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-betBuilderInfo">
                                            <div className="SB-bet-betBuilderInfo__left">
                                                <span className="SB-bet-eventCode">
                                                    20254
                                                </span>
                                                <a
                                                    href=""
                                                    className="SB-bet-fixture">
                                                    Everton v Newcastle{" "}
                                                </a>
                                                <span className="SB-bet-dateandtime">
                                                    {" "}
                                                    @ 30 Jan at 18:00
                                                </span>
                                            </div>
                                            <div className="SB-bet-betBuilderInfo__right"></div>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Everton
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        6.57
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Match Result
                                        </div>

                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Over
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        2.35
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Over/Under 2.5
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-stakeRetuns">
                                <div className="SB-contentBlock SB-betBox-stake">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">Stake:</span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 50.00
                                        </span>
                                    </div>
                                </div>
                                {/* <!-- <div className="SB-contentBlock SB-betBox-tax">
                                                <div className="SB-leftContent">
                                                    <span className="SB-label">WHT 15%:</span>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-value">₦ 85.00</span>
                                                </div>
                                            </div> --> */}
                                <div className="SB-contentBlock SB-betBox-returns">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">
                                            Total Returns:
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 114.00
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="SB-betBox SB-myBet SB-accordion">
                            <div className="SB-betBox-header SB-accordion-header SB-arrowBefore">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <span className="SB-betType">
                                            Single
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-badge SB-won">
                                            ACCEPTED
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-betStatusDetails">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-betID">
                                            ID: AAA42368
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <div className="SB-bonus">
                                            <span>2%</span>
                                            {/* <!-- <span className="sb-icon icon-bonus"></span> --> */}
                                            <div
                                                className="SB-iconSVG "
                                                title="bonus">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    {/* <use xlink:href="images/sprite-other-icons.svg#icon-bonus"></use> */}
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-placedOnDate">
                                            Placed on: 29 Jan at 21:00
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <button className="btn SB-btnPrimary active SB-btnRebet">
                                            Rebet
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-accordion-content">
                                <div className="SB-betBox-content">
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-fixtureInfo">
                                            <span className="SB-bet-eventCode">
                                                20254
                                            </span>
                                            <a
                                                href=""
                                                className="SB-bet-fixture">
                                                Everton v Newcastle{" "}
                                            </a>
                                            <span className="SB-bet-dateandtime">
                                                {" "}
                                                @ 30 Jan at 18:00
                                            </span>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Everton
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.57
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Match Result
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-stakeRetuns">
                                <div className="SB-contentBlock SB-betBox-stake">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">Stake:</span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 50.00
                                        </span>
                                    </div>
                                </div>
                                {/* <!-- <div className="SB-contentBlock SB-betBox-tax">
                                                <div className="SB-leftContent">
                                                    <span className="SB-label">WHT 15%:</span>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-value">₦ 85.00</span>
                                                </div>
                                            </div> --> */}
                                <div className="SB-contentBlock SB-betBox-returns">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">
                                            Total Returns:
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 114.00
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-cashout-container">
                                <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                    Cashout ₦ 94.5
                                </button>
                                <div className="SB-betBox-btnCashout-container">
                                    <button className="btn SB-btnMedium SB-btnCancel">
                                        Cancel
                                    </button>
                                    <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active">
                                        Confirm ₦ 94.5
                                    </button>
                                </div>
                                <div
                                    className="SB-betBox-cashout-betStatusLoader"
                                    id="cashOutloader_36978b53-a8cc-40f3-b542-65b9f5e7565a">
                                    <div className="SB-betBox-cashout-txtContainer">
                                        Waiting
                                    </div>
                                    <div className="SB-loaderSVGIcon" title="2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            width="24px"
                                            height="24px"
                                            viewBox="0 0 50 50"
                                            style={{
                                                enableBackground:
                                                    "new 0 0 32 32",
                                            }}
                                            xmlSpace="preserve">
                                            <path
                                                fill="#000000"
                                                d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                                                <animateTransform
                                                    attributeType="xml"
                                                    attributeName="transform"
                                                    type="rotate"
                                                    from="0 25 25"
                                                    to="360 25 25"
                                                    dur="0.6s"
                                                    repeatCount="indefinite"></animateTransform>
                                            </path>
                                        </svg>
                                    </div>
                                </div>
                                <div
                                    className="SB-betBox-cashout-betStatus SB-success"
                                    id="bnrBsAccepted_9a408e5c-962b-4648-99fb-cc189136aa7d">
                                    <div className="SB-betBox-cashout-txtContainer">
                                        Accept
                                    </div>
                                    <div className="SB-status-icon">
                                        <div className="SB-iconSVG">
                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                {/* <use xlink:href="images/sprite-other-icons.svg#icon-check"></use> */}
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-betBox-cashout-statusMessage SB-success">
                                    Cashout Successfull.
                                </div>
                            </div>
                        </div>
                        <div className="SB-betBox SB-myBet SB-accordion">
                            <div className="SB-betBox-header SB-accordion-header SB-arrowBefore">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <span className="SB-betType">
                                            Multiple (2)
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-badge SB-won">
                                            ACCEPTED
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-betStatusDetails">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-betID">
                                            ID: AAA52364
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <div className="SB-bonus">
                                            <span>2%</span>
                                            {/* <!-- <span className="sb-icon icon-bonus"></span> --> */}
                                            <div
                                                className="SB-iconSVG "
                                                title="bonus">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    {/* <use xlink:href="images/sprite-other-icons.svg#icon-bonus"></use> */}
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-placedOnDate">
                                            Placed on: 26 Jan at 16:54
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <button className="btn SB-btnPrimary active SB-btnRebet">
                                            Rebet
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-accordion-content">
                                <div className="SB-betBox-content">
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-fixtureInfo">
                                            <span className="SB-bet-eventCode">
                                                20254
                                            </span>
                                            <a
                                                href=""
                                                className="SB-bet-fixture">
                                                Everton v Newcastle{" "}
                                            </a>
                                            <span className="SB-bet-dateandtime">
                                                {" "}
                                                @ 30 Jan at 18:00
                                            </span>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Everton
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.95
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Newcastle
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        2.35
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Match Result
                                        </div>
                                    </div>
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-fixtureInfo">
                                            <span className="SB-bet-eventCode">
                                                20254
                                            </span>
                                            <a
                                                href=""
                                                className="SB-bet-fixture">
                                                Crystal Palace v Wolves
                                            </a>
                                            <span className="SB-bet-dateandtime">
                                                {" "}
                                                @ 30 Jan at 18:00
                                            </span>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Under 2.5
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.57
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Over/Under
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-stakeRetuns">
                                <div className="SB-contentBlock SB-betBox-stake">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">Stake:</span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 50.00
                                        </span>
                                    </div>
                                </div>
                                {/* <!-- <div className="SB-contentBlock SB-betBox-tax">
                                                <div className="SB-leftContent">
                                                    <span className="SB-label">WHT 15%:</span>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-value">₦ 85.00</span>
                                                </div>
                                            </div> --> */}
                                <div className="SB-contentBlock SB-betBox-returns">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">
                                            Total Returns:
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 114.00
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="SB-betBox SB-myBet SB-accordion">
                            <div className="SB-betBox-header SB-accordion-header SB-arrowBefore">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <span className="SB-betType">
                                            System (2)
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-badge SB-won">
                                            ACCEPTED
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-betBox-betStatusDetails">
                                <div className="SB-contentBlock">
                                    <div className="SB-leftContent">
                                        <div className="SB-placedOnDate">
                                            Placed on: 26 Jan at 16:54
                                        </div>
                                    </div>
                                    <div className="SB-rightContent">
                                        <button className="btn SB-btnPrimary active SB-btnRebet">
                                            Rebet
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="SB-accordion-content">
                                <div className="SB-betBox-content">
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-fixtureInfo">
                                            <span className="SB-bet-eventCode">
                                                20254
                                            </span>
                                            <a
                                                href=""
                                                className="SB-bet-fixture">
                                                Everton v Newcastle{" "}
                                            </a>
                                            <span className="SB-bet-dateandtime">
                                                {" "}
                                                @ 30 Jan at 18:00
                                            </span>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Everton
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.95
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Newcastle
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        2.35
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Match Result
                                        </div>
                                    </div>
                                    <div className="SB-betBox-betItem">
                                        <div className="SB-bet-fixtureInfo">
                                            <span className="SB-bet-eventCode">
                                                20254
                                            </span>
                                            <a
                                                href=""
                                                className="SB-bet-fixture">
                                                Crystal Palace v Wolves
                                            </a>
                                            <span className="SB-bet-dateandtime">
                                                {" "}
                                                @ 30 Jan at 18:00
                                            </span>
                                        </div>
                                        <div className="SB-bet-marketSelection">
                                            <div className="SB-contentBlock">
                                                <div className="SB-leftContent">
                                                    <div className="SB-bet-outcome">
                                                        Under 2.5
                                                    </div>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-bet-odds">
                                                        1.57
                                                    </span>
                                                    <span className="SB-badge SB-running">
                                                        Running
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="SB-bet-market">
                                            Over/Under
                                        </div>
                                    </div>
                                </div>
                                <div className="SB-table SB-tbl-systemBetCashout">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Bets</th>
                                                <th>Type</th>
                                                <th>ID</th>
                                                <th>Stake</th>
                                                <th className="SB-td-potentialWin">
                                                    Pot. Winnings
                                                </th>
                                                <th className="SB-td-cashout">
                                                    Cashout
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>3</td>
                                                <td>Singles</td>
                                                <td>AAA25468</td>
                                                <td>NGN 100.00</td>
                                                <td className="SB-td-potentialWin">
                                                    <span className="SB-potentialWinLabel">
                                                        Potential Win:{" "}
                                                    </span>
                                                    NGN 52.00
                                                </td>
                                                <td className="SB-td-cashout">
                                                    <div className="SB-betBox-cashout-container">
                                                        <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                                            Cashout ₦ 94.5
                                                        </button>
                                                        <div className="SB-betBox-btnCashout-container d-none">
                                                            <button className="btn SB-btnMedium SB-btnCancel">
                                                                Cancel
                                                            </button>
                                                            <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active">
                                                                Confirm ₦ 94.5
                                                            </button>
                                                        </div>
                                                        <div className="SB-betBox-cashOut-betStatusLoader d-none">
                                                            <div className="SB-betBox-cashOut-betStatusLoader-txtContainer">
                                                                Waiting
                                                            </div>
                                                            <div className="SB-loader"></div>
                                                        </div>
                                                        <div className="SB-betBox-cashOut-betStatus SB-success d-none">
                                                            Cashout Successfull.
                                                        </div>
                                                        <div className="SB-betBox-cashOut-betStatus SB-failure d-none">
                                                            Cashout rejected
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>3</td>
                                                <td>Doubles</td>
                                                <td>AAA25472</td>
                                                <td>NGN 100.00</td>
                                                <td className="SB-td-potentialWin">
                                                    <span className="SB-potentialWinLabel">
                                                        Potential Win:{" "}
                                                    </span>{" "}
                                                    NGN <b>52.00</b> to{" "}
                                                    <b>148.45</b>
                                                </td>
                                                <td className="SB-td-cashout">
                                                    <div className="SB-betBox-cashout-container">
                                                        <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                                            Cashout ₦ 94.5
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Trebles</td>
                                                <td>AAA25481</td>
                                                <td>NGN 100.00</td>
                                                <td className="SB-td-potentialWin">
                                                    <span className="SB-potentialWinLabel">
                                                        Potential Win:{" "}
                                                    </span>{" "}
                                                    NGN <b>52.00</b> to{" "}
                                                    <b>148.45</b>
                                                </td>
                                                <td className="SB-td-cashout">
                                                    <div className="SB-betBox-cashout-container">
                                                        <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                                            Cashout ₦ 94.5
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Yankee</td>
                                                <td>AAA25481</td>
                                                <td>NGN 100.00</td>
                                                <td className="SB-td-potentialWin">
                                                    <span className="SB-potentialWinLabel">
                                                        Potential Win:{" "}
                                                    </span>{" "}
                                                    NGN <b>52.00</b> to{" "}
                                                    <b>148.45</b>
                                                </td>
                                                <td className="SB-td-cashout">
                                                    <div className="SB-betBox-cashout-container">
                                                        <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                                            Cashout ₦ 94.5
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Lucky 15</td>
                                                <td>AAA25481</td>
                                                <td>NGN 100.00</td>
                                                <td className="SB-td-potentialWin">
                                                    <span className="SB-potentialWinLabel">
                                                        Potential Win:{" "}
                                                    </span>{" "}
                                                    NGN <b>52.00</b> to{" "}
                                                    <b>148.45</b>
                                                </td>
                                                <td className="SB-td-cashout">
                                                    <div className="SB-betBox-cashout-container">
                                                        <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                                            Cashout ₦ 94.5
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Permed Patent</td>
                                                <td>AAA25481</td>
                                                <td>NGN 100.00</td>
                                                <td className="SB-td-potentialWin">
                                                    <span className="SB-potentialWinLabel">
                                                        Potential Win:{" "}
                                                    </span>{" "}
                                                    NGN <b>52.00</b> to{" "}
                                                    <b>148.45</b>
                                                </td>
                                                <td className="SB-td-cashout">
                                                    <div className="SB-betBox-cashout-container">
                                                        <button className="btn SB-btnSecondary SB-btnMedium SB-btnCashout active ">
                                                            Cashout ₦ 94.5
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="SB-betBox-stakeRetuns">
                                <div className="SB-contentBlock SB-betBox-stake">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">Stake:</span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 50.00
                                        </span>
                                    </div>
                                </div>
                                {/* <!-- <div className="SB-contentBlock SB-betBox-tax">
                                                <div className="SB-leftContent">
                                                    <span className="SB-label">WHT 15%:</span>
                                                </div>
                                                <div className="SB-rightContent">
                                                    <span className="SB-value">₦ 85.00</span>
                                                </div>
                                            </div> --> */}
                                <div className="SB-contentBlock SB-betBox-returns">
                                    <div className="SB-leftContent">
                                        <span className="SB-label">
                                            Total Returns:
                                        </span>
                                    </div>
                                    <div className="SB-rightContent">
                                        <span className="SB-value">
                                            ₦ 114.00
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default MyBets;
